import { render } from "./SaleBovineCard.vue?vue&type=template&id=54dbab88&scoped=true"
import script from "./SaleBovineCard.vue?vue&type=script&lang=js"
export * from "./SaleBovineCard.vue?vue&type=script&lang=js"

import "./SaleBovineCard.vue?vue&type=style&index=0&id=54dbab88&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dbab88"]])

export default __exports__